var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    d: "M18.3333 7.08268C18.3333 10.0743 15.9083 12.4993 12.9167 12.4993C12.775 12.4993 12.625 12.491 12.4833 12.4827C12.275 9.84101 10.1583 7.72435 7.51666 7.51602C7.50832 7.37435 7.5 7.22435 7.5 7.08268C7.5 4.09102 9.925 1.66602 12.9167 1.66602C15.9083 1.66602 18.3333 4.09102 18.3333 7.08268Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M12.4993 12.9167C12.4993 15.9083 10.0743 18.3333 7.08268 18.3333C4.09102 18.3333 1.66602 15.9083 1.66602 12.9167C1.66602 9.925 4.09102 7.5 7.08268 7.5C7.22435 7.5 7.37434 7.50834 7.51601 7.51667C10.1577 7.725 12.2744 9.84166 12.4827 12.4833C12.491 12.625 12.4993 12.775 12.4993 12.9167Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M6.35 12.184L7.08333 10.834L7.81667 12.184L9.16667 12.9173L7.81667 13.6507L7.08333 15.0007L6.35 13.6507L5 12.9173L6.35 12.184Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCrypto);
export default __webpack_public_path__ + "static/media/buy-crypto.766ce1671a6e45899eeaa531ffc3486e.svg";
export { ForwardRef as ReactComponent };